import api from './axios';

// Register new user
export const register = async (userData) => {
  const response = await api.post('/auth/register', userData);
  return response.data;
};

// Login user
export const login = async (credentials) => {
  const response = await api.post('/auth/login', credentials);
  return response.data;
};

// Get active tenants for admin login dropdown
export const getLoginTenants = async () => {
  const response = await api.get('/auth/tenants');
  return response.data;
};

// Get current user
export const getCurrentUser = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

// Request OTP
export const requestOtp = async (email, tenant_id) => {
  const payload = { email };
  if (tenant_id) payload.tenant_id = tenant_id;
  const response = await api.post('/auth/request-otp', payload);
  return response.data;
};

// Verify OTP
export const verifyOtp = async (email, otp, tenant_id) => {
  const payload = { email, otp };
  if (tenant_id) payload.tenant_id = tenant_id;
  const response = await api.post('/auth/verify-otp', payload);
  return response.data;
};

// Update password (for authenticated users)
export const updatePassword = async (password) => {
  const response = await api.post('/auth/update-password', { password });
  return response.data;
};

// Logout (client-side only, clears token)
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};



